import * as React from 'react'
import { useMatch, useParams } from 'react-router-dom-v5-compat'

import { commentsChannel, commentsPage } from '~publish/legacy/routes'
import { PusherEvent, usePusherEvent } from '~publish/services/pusher'

type NewCommentReceivedHookResponse = {
  showNewCommentsButton: boolean
  hideNewCommentsButton: () => void
}

type UseNewCommentsAvailableButtonProps = {
  channelId?: string
}

type CommentIngestedEventData = {
  channelId?: string
}

export const useNewCommentsAvailableButton = ({
  channelId: propChannelId,
}: UseNewCommentsAvailableButtonProps = {}): NewCommentReceivedHookResponse => {
  const [showNewCommentsButton, setShowNewCommentsButton] =
    React.useState(false)

  const hideNewCommentsButton = React.useCallback(() => {
    setShowNewCommentsButton(false)
  }, [])

  const commentsPageMatch = useMatch(commentsPage.route)
  const channelPageMatch = useMatch(commentsChannel.route)
  const channelBasePageMatch = useMatch(commentsChannel.baseRoute)
  const isCommentsPage =
    !!commentsPageMatch || !!channelPageMatch || !!channelBasePageMatch

  // Extract channelId from URL params when on a channel-specific route
  const { channelId: urlChannelId } = useParams<{
    channelId: string
    view?: string
  }>()

  // Use prop channelId if provided, otherwise use URL channelId
  const channelId = propChannelId || urlChannelId

  /**
   * Subscription to COMMENT_INGESTED event
   */
  usePusherEvent(
    PusherEvent.COMMENT_INGESTED,
    (data: CommentIngestedEventData): void => {
      if (isCommentsPage) {
        const shouldShowButton =
          !channelId || // Show if no specific channel filter
          !data.channelId || // Show if event has no channel info
          channelId === data.channelId // Show if channels match
        setShowNewCommentsButton(shouldShowButton)
      } else {
        setShowNewCommentsButton(false)
      }
    },
  )

  return { showNewCommentsButton, hideNewCommentsButton }
}
